// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

// Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

// Auth const
export const SET_DASHBOARD_FILTER = 'SET_DASHBOARD_FILTER';
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const INIT_URL = 'INIT_URL';
export const USER_DATA = 'user_data';
export const USER_TOKEN_SET = 'user_token_set';
export const FORGOT_PASSWORD_USER = 'forgot_password_user';
export const UPDATE_LOADING = 'update_loading';
export const UPDATE_ERROR = 'update_error';
export const UPDATE_MESSAGE = 'update_message';
export const RESET_PASSWORD_USER = 'reset_password_user';
export const FETCH_USER_DATA = 'fetch_user_data';
export const UPDATE_USER_PROFILE = 'update_user_profile';
export const UPDATE_USER_AVATAR = 'update_user_avatar';
export const CHANGE_PASSWORD_USER = 'change_password_user';
export const SET_TENANT_SUB = 'SET_TENANT_SUB';

// Location const
export const FETCH_CITY = 'fetch_city';
export const FETCH_CITY_SUCCESS = 'fetch_city_success';
export const FETCH_DISTRICT_BY_CITY = 'fetch_district_by_city';
export const FETCH_DISTRICT_SUCCESS = 'fetch_district_success';
export const FETCH_COUNTRY = 'fetch_country';
export const FETCH_COUNTRY_SUCCESS = 'fetch_country_success';

// Partner const
export const FETCH_PARTNER_LIST = 'fetch_partner_list';
export const FETCH_PARTNER_LIST_SUCCESS = 'fetch_partner_success';
export const CREATE_PARTNER = 'create_partner';
export const FETCH_BILLING_DISTRICT = 'fetch_billing_district';
export const FETCH_BILLING_DISTRICT_SUCCESS = 'fetch_billing_district_success';
export const FETCH_SHIPPING_DISTRICT = 'fetch_shipping_district';
export const FETCH_SHIPPING_DISTRICT_SUCCESS = 'fetch_shipping_district_success';
export const FETCH_PARTNER_DETAIL = 'fetch_partner_detail';
export const FETCH_PARTNER_DETAIL_SUCCESS = 'fetch_partner_detail_success';
export const RESET_PARTNER_FORM = 'reset_partner_form';
export const UPDATE_PARTNER = 'update_partner';
export const CHANGE_PARTNER_FORM = 'change_partner_form';

// Unit const
export const FETCH_UNIT_LIST = 'fetch_unit_list';
export const FETCH_UNIT_LIST_SUCCESS = 'fetch_unit_list_success';
export const CREATE_UNIT = 'create_unit';
export const UPDATE_UNIT = 'update_unit';

// Category const
export const FETCH_CATEGORY_LIST = 'fetch_category_list';
export const FETCH_CATEGORY_LIST_SUCCESS = 'fetch_category_list_success';
export const CREATE_CATEGORY = 'create_category';
export const UPDATE_CATEGORY = 'update_category';

// Product const
export const FETCH_PRODUCT_LIST = 'fetch_product_list';
export const FETCH_PRODUCT_LIST_SUCCESS = 'fetch_product_list_success';
export const INIT_PRODUCT_FORM = 'init_product_form';
export const CREATE_PRODUCT = 'create_product';
export const FETCH_PRODUCT_DETAIL = 'fetch_product_detail';
export const FETCH_PRODUCT_DETAIL_SUCCESS = 'fetch_product_detail_success';
export const RESET_PRODUCT_FORM = 'reset_product_form';
export const CHANGE_PRODUCT_IS_DRUG = 'change_product_is_drug';
export const CHANGE_PRODUCT_STATUS = 'change_product_status';
export const CHANGE_PRODUCT_STATUS_SUCCESS = 'change_product_status_success';
export const UPDATE_PRODUCT = 'update_product';

// Drug const
export const FETCH_DRUG_LIST = 'fetch_drug_list';
export const FETCH_DRUG_LIST_SUCCESS = 'fetch_drug_list_success';
export const FETCH_DRUG_DETAIL = 'fetch_drug_detail';
export const FETCH_DRUG_DETAIL_SUCCESS = 'fetch_drug_detail_success';
export const RESET_DRUG_DETAIL = 'reset_drug_detail';

// Purchase Order const
export const FETCH_PURCHASE_ORDER_LIST = 'fetch_purchase_order_list';
export const FETCH_PURCHASE_ORDER_LIST_SUCCESS = 'fetch_purchase_order_list_success';
export const FETCH_PURCHASE_ORDER_ITEM = 'fetch_purchase_order_item';
export const FETCH_PURCHASE_ORDER_ITEM_SUCCESS = 'fetch_purchase_order_item_success';
export const INIT_PURCHASE_ORDER_FORM = 'init_purchase_order_form';
export const INIT_PURCHASE_ORDER_FORM_SUCCESS = 'init_purchase_order_form_success';
export const REMOVE_PURCHASE_ORDER_ITEM = 'remove_purchase_order_item';
export const PURCHASE_ORDER_TABLE_CHANGE = 'purchase_order_table_change';
export const RESET_PURCHASE_ORDER_FORM = 'reset_purchase_order_form';
export const CREATE_PURCHASE_ORDER = 'create_purchase_order';
export const FETCH_PURCHASE_ORDER_DETAIL = 'fetch_purchase_order_detail';
export const FETCH_PURCHASE_ORDER_DETAIL_SUCCESS = 'fetch_purchase_order_detail_success';
export const EDIT_PURCHASE_ORDER = 'edit_purchase_order';
export const CANCEL_EDIT_PURCHASE_ORDER = 'cancel_edit_purchase_order';
export const CANCEL_EDIT_PURCHASE_ORDER_SUCCESS = 'cancel_edit_purchase_order_success';
export const PRINT_PURCHASE_ORDER = 'print_purchase_order';
export const UPDATE_PURCHASE_ORDER = 'update_purchase_order';
export const UPDATE_PURCHASE_ORDER_SUCCESS = 'update_purchase_order_success';
export const CONFIRM_PURCHASE_ORDER = 'confirm_purchase_order';
export const CONFIRM_PURCHASE_ORDER_SUCCESS = 'confirm_purchase_order_success';

// Receipt const
export const FETCH_INIT_RECEIPT = 'fetch_init_receipt';
export const FETCH_INIT_RECEIPT_SUCCESS = 'fetch_init_receipt_success';
export const RECEIPT_TABLE_CHANGE = 'receipt_table_change';
export const REMOVE_RECEIPT_ITEM = 'remove_receipt_item';
export const ADD_RECEIPT_ITEM_LOTS = 'add_receipt_item_lots';
export const CREATE_RECEIPT = 'create_receipt';
export const FETCH_RECEIPT_DETAIL = 'fetch_receipt_detail';
export const FETCH_RECEIPT_DETAIL_SUCCESS = 'fetch_receipt_detail_success';
export const RESET_RECEIPT_ITEMS_MODAL = 'reset_receipts_item_modal';
export const RESET_RECEIPT_FORM = 'reset_receipt_form';

// Bill const
export const FETCH_BILL_LIST = 'fetch_bill_list';
export const FETCH_BILL_LIST_SUCCESS = 'fetch_bill_list_success';
export const FETCH_BILL_DETAIL = 'fetch_bill_detail';
export const FETCH_BILL_DETAIL_SUCCESS = 'fetch_bill_detail_success';
export const RESET_PAID = 'reset_paid';

// Payment const
export const CREATE_PAYMENT = 'create_payment';
export const CREATE_PAYMENT_SUCCESS = 'create_payment_success';

// Inventory const
export const FETCH_INVENTORY_LIST = 'fetch_inventory_list';
export const FETCH_INVENTORY_LIST_SUCCESS = 'fetch_inventory_list_success';
export const CHECK_INVENTORY_STATUS = 'check_inventory_status';
export const FETCH_INVENTORY_ITEM = 'fetch_inventory_item';
export const FETCH_INVENTORY_ITEM_SUCCESS = 'fetch_inventory_item_success';
export const INVENTORY_TABLE_CHANGE = 'inventory_table_change';
export const REMOVE_INVENTORY_ITEM = 'remove_inventory_item';
export const INVENTORY_LOT_CHANGE = 'inventory_lot_change';
export const CREATE_INVENTORY = 'create_inventory';
export const FETCH_INVENTORY_DETAIL = 'fetch_inventory_detail';
export const FETCH_INVENTORY_DETAIL_SUCCESS = 'fetch_inventory_detail_success';
export const UPDATE_INVENTORY = 'update_inventory';
export const UPDATE_INVENTORY_SUCCESS = 'update_inventory_success';
export const RESET_INVENTORY_FORM = 'reset_inventory_form';
export const CONFIRM_INVENTORY = 'confirm_inventory';
export const CONFIRM_INVENTORY_SUCCESS = 'confirm_inventory_success';
export const CANCEL_INVENTORY = 'cancel_inventory';
export const CANCEL_INVENTORY_SUCCESS = 'cancel_inventory_success';

// Scrap const
export const FETCH_SCRAP_LIST = 'fetch_scrap_list';
export const FETCH_SCRAP_LIST_SUCCESS = 'fetch_scrap_list_success';
export const FETCH_SCRAP_PRODUCT = 'fetch_scrap_product';
export const FETCH_SCRAP_PRODUCT_SUCCESS = 'fetch_scrap_product_success';
export const CREATE_SCRAP = 'create_scrap';
export const FETCH_SCRAP_DETAIL = 'fetch_scrap_detail';
export const FETCH_SCRAP_DETAIL_SUCCESS = 'fetch_scrap_detail_success';
export const UPDATE_SCRAP = 'update_scrap';
export const CONFIRM_SCRAP = 'confirm_scrap';
export const CONFIRM_SCRAP_SUCCESS = 'confirms_scrap_success';
export const RESET_SCRAP_FORM = 'reset_scrap_form';

// Report const
export const FETCH_REPORT_MAIN = 'fetch_report_main';
export const FETCH_REPORT_MAIN_SUCCESS = 'fetch_report_main_success';
export const FETCH_REPORT_POS_ORDER_SUMMARY = 'fetch_report_order_summary';
export const FETCH_REPORT_POS_ORDER_SUMMARY_SUCCESS = 'fetch_report_order_summary_success';
export const FETCH_TOP_PRODUCTS_SOLD = 'fetch_top_products_sold';
export const FETCH_TOP_PRODUCTS_SOLD_SUCCESS = 'fetch_top_products_sold_success';
export const FETCH_INVENTORY_VALUATION = 'fetch_inventory_valuation';
export const FETCH_INVENTORY_VALUATION_SUCCESS = 'fetch_inventory_valuation_success';
export const EXPORT_INVENTORY_VALUATION = 'export_inventory_valuation';
export const FETCH_REPORT_GROSS_PROFIT_SUMMARY = 'fetch_report_gross_profit_summary';
export const FETCH_REPORT_GROSS_PROFIT_SUMMARY_SUCCESS = 'fetch_report_gross_profit_summary_success';

// POS const
export const SET_LOADING_PAGE = 'SET_LOADING_PAGE';
export const CONTINUE_SELL = 'CONTINUE_SELL';
export const TOGGLE_MEDICAL_FORM = 'TOGGLE_MEDICAL_FORM';
export const SET_CURRENT_POS_CATEGORY = 'SET_CURRENT_POS_CATEGORY';
export const SET_POS_LAYOUT = 'SET_POS_LAYOUT';
export const ADD_RETURN_ORDER_TO_CURRENT_ORDER = 'ADD_RETURN_ORDER_TO_CURRENT_ORDER';
export const TOGGLE_RETURN_ORDER_MODAL = 'TOGGLE_RETURN_ORDER_MODAL';
export const CHANGE_TOTAL_PAID = 'CHANGE_TOTAL_PAID';
export const POS_PRINT = 'POS_PRINT';
export const SHOW_POS_ORDER = 'SHOW_POS_ORDER';
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
export const ADD_PRINT_ORDER = 'add_print_order';
export const REMOVE_PRINT_ORDER = 'remove_print_order';
export const ADD_PARKED_ORDER_TO_CURRENT_ORDER = 'ADD_PARKED_ORDER_TO_CURRENT_ORDER';
export const REMOVE_PARKED_ORDER = 'remove_parked_order';
export const SET_PARKED_ORDERS = 'SET_PARKED_ORDERS';
export const CHANGE_ORDER_TYPE = 'CHANGE_ORDER_TYPE';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const POS_SET_LOADING = 'POS_SET_LOADING';
export const UPDATE_ORDER_SUMMARY = 'UPDATE_ORDER_SUMMARY';
export const CHANGE_ORDER_DISCOUNT_TYPE = 'CHANGE_ORDER_DISCOUNT_TYPE';
export const UPDATE_ORDER_DISCOUNT = 'UPDATE_ORDER_DISCOUNT';
export const TOGGLE_CUSTOMER_MODAL = 'TOGGLE_CUSTOMER_MODAL';
export const REMOVE_CURRENT_CUSTOMER = 'REMOVE_CURRENT_CUSTOMER';
export const ADD_CURRENT_CUSTOMER = 'ADD_CURRENT_CUSTOMER';
export const REMOVE_CURRENT_ORDER = 'remove_current_order';
export const UPDATE_CURRENT_ORDER_NOTE = 'UPDATE_CURRENT_ORDER_NOTE';
export const HIDE_ALL_ORDER_ITEM_NOTE = 'HIDE_ALL_ORDER_ITEM_NOTE';
export const UPDATE_ORDER_ITEM_NOTE = 'UPDATE_ORDER_ITEM_NOTE';
export const REMOVE_ORDER_ITEM = 'REMOVE_ORDER_ITEM';
export const UPDATE_ORDER_ITEM = 'UPDATE_ORDER_ITEM';
export const ADD_ORDER_ITEM = 'ADD_ORDER_ITEM';
export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER';
export const FETCH_CURRENT_ORDER_SUCCESS = 'fetch_current_order_success';
export const POS_OPEN_SESSION = 'pos_open_session';
export const POS_OPEN_SESSION_SUCCESS = 'pos_open_session_success';
export const FETCH_POS_PRODUCT = 'fetch_pos_product';
export const FETCH_POS_PRODUCT_SUCCESS = 'fetch_pos_product_success';
export const POS_CHECKOUT = 'POS_CHECKOUT';
export const POS_CHECKOUT_SUCCESS = 'pos_checkout_success';
export const CREATE_CUSTOMER_IN_POS = 'create_customer_in_pos';
export const CREATE_CUSTOMER_IN_POS_SUCCESS = 'create_customer_in_pos_success';
export const RESET_CUSTOMER_SELECT = 'reset_customer_select';
export const FETCH_SESSION = 'fetch_session';
export const FETCH_SESSION_SUCCESS = 'fetch_session_success';
export const SESSION_TABLE_CHANGE = 'session_table_change';
export const POS_CLOSE_SESSION = 'pos_close_session';
export const POS_CLOSE_SESSION_SUCCESS = 'pos_close_session_success';
export const FETCH_CURRENT_REGISTER = 'fetch_current_register';
export const FETCH_CURRENT_REGISTER_SUCCESS = 'fetch_pos_register_success';
export const CHANGE_TO_POS_RETURN = 'change_to_pos_return';
export const CHANGE_TO_POS_RETURN_SUCCESS = 'change_to_pos_return_success';
export const CHANGE_POS_TYPE = 'change_pos_type';
export const RESET_POS = 'reset_pos';
export const RESET_REGISTER = 'reset_register';
export const TOGGLE_COMPLETED = 'toggle_completed';
export const TOGGLE_COMPLETED_SUCCESS = 'toggle_completed_success';
export const TOGGLE_POS_CHECKOUT = 'toggle_poscheckout';
export const TOGGLE_POS_CHECKOUT_SUCCESS = 'toggle_poscheckout_success';
export const TOGGLE_MODAL_ADD_NEW_CUSTOMER = 'toggle_modal_add_new_customer';
export const TOGGLE_MODAL_ADD_NEW_CUSTOMER_SUCCESS = 'toggle_modal_add_new_customer_success';
export const SET_CURRENT_FOLDER = 'set_current_folder';
export const ADD_PRESCRIPTION_TO_CURRENT_ORDER = 'add_prescription_to_current_order';
export const UPDATE_PRESCRIPTION = 'update_prescription';
export const ADD_PRESCRIPTION_TEMPLATE_TO_CURRENT_ORDER = 'add_prescription_template_to_current_order';
export const ADD_CURRENT_DOCTOR = 'add_current_doctor';
export const UPDATE_CURRENT_DOCTOR = 'update_current_doctor';
export const UPDATE_POS_RESULTS_STATUS = 'update_pos_results_status';
export const UPDATE_ALL_POS_LAYOUT_ITEMS_STATUS = 'update_all_pos_layout_items_status';

// POS Order Const
export const FETCH_POS_ORDER_LIST = 'fetch_pos_order_list';
export const FETCH_POS_ORDER_LIST_SUCCESS = 'fetch_pos_order_list_success';
export const FETCH_POS_ORDER_DETAIL = 'fetch_order_detail';
export const FETCH_POS_ORDER_DETAIL_SUCCESS = 'fetch_order_detail_success';
export const FETCH_POS_ORDER_RECENT_LIST = 'fetch_pos_order_recent_list';
export const FETCH_POS_ORDER_RECENT_LIST_SUCCESS = 'fetch_pos_order_recent_list_success';

// Tax Const
export const FETCH_TAX_LIST = 'fetch_tax_list';
export const FETCH_TAX_LIST_SUCCESS = 'fetch_tax_list_success';
export const CREATE_TAX = 'create_tax';
export const UPDATE_TAX = 'update_tax';

// Config Const
export const SIDEBAR_COLLAPSE = 'SIDEBAR_COLLAPSE';
export const SIDEBAR_STATE = 'SIDEBAR_STATE';
export const UPDATE_WINDOW_WIDTH = 'UPDATE_WINDOW_WIDTH';
export const FETCH_GENERAL_CONFIG = 'fetch_general_config';
export const FETCH_GENERAL_CONFIG_SUCCESS = 'fetch_general_config_success';
export const UPDATE_DEFAULT_TAX_CONFIG = 'update_default_tax_config';
export const UPDATE_DEFAULT_TAX_CONFIG_SUCCESS = 'update_default_tax_config_success';

// Prescription const
export const INIT_PRESCRIPTION_TEMPLATE_DATA = 'init_prescription_template_data';
export const ADD_PRESCRIPTION_TEMPLATE_ITEM = 'add_prescription_template_item';
export const CHANGE_PRESCRIPTION_TEMPLATE_ITEM_QUANTITY = 'change_prescription_item_quantity';
export const DELETE_PRESCRIPTION_TEMPLATE_ITEM = 'delete_prescription_item_quantity';
export const RESET_PRESCRIPTION_TEMPLATE_ITEM = 'reset_prescription_template_item';
